const scopeLevelConfig = {
    // realm get msp & standalone org list
    "/me/memberships.read": {
        protocol: "ws",
        resource: "/me/memberships",
        restful: true,
        method: "read",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // realm get msp/org list
    "/ents/:entId/orgs.read": {
        protocol: "ws",
        resource: "/ents/:entId/orgs",
        restful: true,
        method: "read",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // realm get msp/org/site list
    "/ents/:entId/orgs/:orgId/sites.read": {
        protocol: "ws",
        resource: "/ents/:entId/orgs/:orgId/sites",
        restful: true,
        method: "read",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // realm get org/site list
    "/orgs/:orgId/sites.read": {
        protocol: "ws",
        resource: "/orgs/:orgId/sites",
        restful: true,
        method: "read",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // API/gluon/organizations => /orgs (Create standalone)
    "/orgs.create": {
        protocol: "ws",
        resource: "/orgs",
        restful: true,
        method: "create",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // API/gluon/enterprise => /ents/{entId}/orgs
    "/ents/:entId/orgs.create": {
        protocol: "ws",
        resource: "/ents/:entId/orgs",
        restful: true,
        method: "create",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // API/gluon/organizations => /ents/{entId}/orgs/{orgId}/sites
    "/ents/:entId/orgs/:orgId/sites.create": {
        protocol: "ws",
        resource: "/ents/:entId/orgs/:orgId/sites",
        restful: true,
        method: "create",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
    // API/gluon/organizations => /orgs/{orgId}/sites (standalone)
    "/orgs/:orgId/sites.create": {
        protocol: "ws",
        resource: "/orgs/:orgId/sites",
        restful: true,
        method: "create",
        buildParams: null,
        action: null,
        mockSelector: "scopeLevel",
    },
};

export default scopeLevelConfig;